import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './style.css';
import "/@/views/assets/css/iconfont/iconfont.css";
import "/@/views/assets/css/iconfont/iconfont.js";
import "/@/views/assets/css/fontAwesome/css/font-awesome.min.css";
import 'viewerjs/dist/viewer.css';
import Vue3Marquee from 'vue3-marquee';
import VueViewer from 'v-viewer';
import pinia from './store/index.js';
import App from './App.vue';
import i18n from './i18n/index';
import router from './router/index';

import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'



let app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(VxeTable)
app.use(VxeUI)
app.use(VueViewer)
app.use(pinia)
app.use(i18n)
app.use(ElementPlus)
app.use(Vue3Marquee,{name:'Marquee'})//跑马灯
app.use(router)
app.mount('#app')

